<template>
	<div>
	<section id="slider" class="slider-element slider-parallax full-screen dark error404-wrap slider-parallax-visible" style="background: url(http://themes.semicolonweb.com/html/canvas/images/landing/static.jpg) center center; height: 100vh;">
<div class="slider-parallax-inner" style="height: 100vh; transform: translateY(0px);">
<div class="container-fluid vertical-middle center clearfix" style="position: absolute; top: 50%; width: 100%; padding-top: 0px; padding-bottom: 0px; margin-top: -176px; opacity: 1.296;">
<div class="error404">404</div>
<div class="heading-block nobottomborder">
<h4>Ooopps.! The Page you were looking for, couldn't be found.</h4>
<span>Try the search below to find matching pages:</span>
</div>

</div>
</div>
</section>
	</div>
</template>

<script>
	export default {
		name:'404',

	
	}
</script>

<style scoped>
	/*! CSS Used from: http://themes.semicolonweb.com/html/canvas/css/bootstrap.css */
*,*::before,*::after{box-sizing:border-box;}
section{display:block;}
h4{margin-top:0;margin-bottom:.5rem;}
button{border-radius:0;}
button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color;}
input,button{margin:0;font-family:inherit;font-size:inherit;line-height:inherit;}
button,input{overflow:visible;}
button{text-transform:none;}
button,[type=button]{-webkit-appearance:button;}
button::-moz-focus-inner,[type=button]::-moz-focus-inner{padding:0;border-style:none;}
h4{margin-bottom:.5rem;font-weight:500;line-height:1.2;}
h4{font-size:1.5rem;}
.container-fluid{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto;}
.form-control{display:block;width:100%;height:calc(1.5em + 0.75rem + 2px);padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;}
@media (prefers-reduced-motion:reduce){
.form-control{transition:none;}
}
.form-control::-ms-expand{background-color:transparent;border:0;}
.form-control:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25);}
.form-control::-webkit-input-placeholder{color:#6c757d;opacity:1;}
.form-control::-moz-placeholder{color:#6c757d;opacity:1;}
.form-control:-ms-input-placeholder{color:#6c757d;opacity:1;}
.form-control::-ms-input-placeholder{color:#6c757d;opacity:1;}
.form-control::placeholder{color:#6c757d;opacity:1;}
.form-control:disabled{background-color:#e9ecef;opacity:1;}
.btn{display:inline-block;font-weight:400;color:#212529;text-align:center;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;}
@media (prefers-reduced-motion:reduce){
.btn{transition:none;}
}
.btn:hover{color:#212529;text-decoration:none;}
.btn:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25);}
.btn:disabled{opacity:.65;}
.btn-danger{color:#fff;background-color:#dc3545;border-color:#dc3545;}
.btn-danger:hover{color:#fff;background-color:#c82333;border-color:#bd2130;}
.btn-danger:focus{box-shadow:0 0 0 .2rem rgba(225,83,97,.5);}
.btn-danger:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545;}
.input-group{position:relative;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:stretch;align-items:stretch;width:100%;}
.input-group>.form-control{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;width:1%;margin-bottom:0;}
.input-group>.form-control:focus{z-index:3;}
.input-group>.form-control:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0;}
.input-group-append{display:-ms-flexbox;display:flex;}
.input-group-append .btn{position:relative;z-index:2;}
.input-group-append .btn:focus{z-index:3;}
.input-group-append{margin-left:-1px;}
.input-group-lg>.form-control:not(textarea){height:calc(1.5em + 1rem + 2px);}
.input-group-lg>.form-control,.input-group-lg>.input-group-append>.btn{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem;}
.input-group>.input-group-append>.btn{border-top-left-radius:0;border-bottom-left-radius:0;}
.clearfix::after{display:block;clear:both;content:"";}
@media print{
*,*::before,*::after{text-shadow:none!important;box-shadow:none!important;}
}
/*! CSS Used from: http://themes.semicolonweb.com/html/canvas/style.css */
::selection{background:#1abc9c;color:#fff;text-shadow:none;}
::-moz-selection{background:#1abc9c;color:#fff;text-shadow:none;}
::-webkit-selection{background:#1abc9c;color:#fff;text-shadow:none;}
:active,:focus{outline:0!important;}
h4{color:#444;font-weight:600;line-height:1.5;margin:0 0 30px;font-family:Raleway,sans-serif;}
h4{font-size:18px;}
h4{font-weight:600;}
form{margin-bottom:30px;}
.nobottommargin{margin-bottom:0!important;}
.nobottomborder{border-bottom:none!important;}
.center{text-align:center!important;}
.divcenter{position:relative!important;float:none!important;margin-left:auto!important;margin-right:auto!important;}
.vertical-middle{height:auto!important;left:0;max-width:none!important;z-index:2;}
#header.transparent-header+#slider{top:-100px;margin-bottom:-100px;}
.slider-element{position:relative;width:100%;overflow:hidden;}
.slider-parallax{position:relative;}
.slider-parallax{visibility:visible;-webkit-backface-visibility:hidden;}
.slider-parallax .slider-parallax-inner{position:fixed;width:100%;height:100%;}
body:not(.side-header) .slider-parallax .slider-parallax-inner{left:0;}
#header.transparent-header+.slider-parallax .slider-parallax-inner{top:0;}
.slider-parallax .slider-parallax-inner{will-change:transform;-webkit-transform:translate3d(0,0,0);-webkit-transition:transform 0s linear;-webkit-backface-visibility:hidden;}
.form-control{border-radius:3px;}
.form-control:active,.form-control:focus{border-color:#999;box-shadow:none;}
.heading-block{margin-bottom:50px;}
.heading-block h4{margin-bottom:0;font-weight:700;text-transform:uppercase;letter-spacing:1px;color:#333;}
.heading-block h4{font-size:20px;font-weight:700;}
.heading-block>span:not(.before-heading){display:block;margin-top:10px;font-weight:300;color:#777;}
.center .heading-block>span{max-width:700px;margin-left:auto;margin-right:auto;}
.heading-block h4+span{font-size:20px;}
.heading-block:after{content:'';display:block;margin-top:30px;width:40px;border-top:2px solid #444;}
.center .heading-block:after{margin:30px auto 0;}
.heading-block.nobottomborder:after{display:none;}
.error404{display:block;font-size:216px;font-weight:700;color:#ddd;line-height:1.35;letter-spacing:4px;}
.error404-wrap .error404{line-height:.9;margin-bottom:40px;font-weight:700;font-size:244px;color:#fff!important;opacity:.2;text-shadow:1px 1px 5px rgba(0,0,0,.4);}
.error404-wrap .heading-block h4{font-weight:300;margin-bottom:8px;}
.error404-wrap .heading-block span{font-size:17px;}
.error404-wrap form{max-width:500px;}
/*! CSS Used from: http://themes.semicolonweb.com/html/canvas/css/dark.css */
.dark,.dark h4{color:#eee;}
.dark .heading-block:not(.not-dark):after{border-top-color:rgba(255,255,255,.4);}
.dark .heading-block:not(.not-dark){text-shadow:1px 1px 1px rgba(0,0,0,.1);}
.dark .heading-block:not(.not-dark) h4{color:#fff;}
.dark .heading-block:not(.not-dark)>span{color:#eee;}
.dark .error404{color:rgba(255,255,255,.15);}
.dark.error404-wrap .form-control::-webkit-input-placeholder{color:#888;}
.dark.error404-wrap .form-control::-moz-placeholder{color:#888;}
.dark.error404-wrap .form-control:-ms-input-placeholder{color:#888;}
.dark .form-control:not(.not-dark){color:#999;background-color:rgba(0,0,0,.2);border-color:rgba(0,0,0,.25);}
.dark .form-control:not(.not-dark):active,.dark .form-control:not(.not-dark):focus{background-color:rgba(0,0,0,.3);border-color:rgba(0,0,0,.25)!important;}
.dark .form-control:not(.not-dark)::-moz-placeholder{color:#666;}
.dark .form-control:not(.not-dark):-ms-input-placeholder{color:#666;}
.dark .form-control:not(.not-dark)::-webkit-input-placeholder{color:#666;}
.dark .btn:hover,.dark .btn:focus{color:#fff;}
/*! CSS Used from: http://themes.semicolonweb.com/html/canvas/css/magnific-popup.css */
button::-moz-focus-inner{padding:0;border:0;}
/*! CSS Used from: http://themes.semicolonweb.com/html/canvas/css/responsive.css */
@media (max-width:991.98px){
#header.transparent-header+#slider{top:0;margin-bottom:0;}
.slider-parallax .slider-parallax-inner{position:relative;}
.error404{font-size:180px;}
}
@media (max-width:767.98px){
h4{font-size:16px;}
.heading-block h4{font-size:19px;}
.heading-block h4+span{font-size:17px;}
}
@media (min-width:576px) and (max-width:767.98px){
.error404,.error404-wrap .error404{font-size:160px;}
}
@media (max-width:575.98px){
.error404,.error404-wrap .error404{font-size:120px;}
}
/*! CSS Used fontfaces */
@font-face{font-family:'Raleway';font-style:normal;font-weight:300;src:local('Raleway Light'), local('Raleway-Light'), url(https://fonts.gstatic.com/s/raleway/v13/1Ptrg8zYS_SKggPNwIYqWqhPAMif.woff2) format('woff2');unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Raleway';font-style:normal;font-weight:300;src:local('Raleway Light'), local('Raleway-Light'), url(https://fonts.gstatic.com/s/raleway/v13/1Ptrg8zYS_SKggPNwIYqWqZPAA.woff2) format('woff2');unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
@font-face{font-family:'Raleway';font-style:normal;font-weight:400;src:local('Raleway'), local('Raleway-Regular'), url(https://fonts.gstatic.com/s/raleway/v13/1Ptug8zYS_SKggPNyCMIT5lu.woff2) format('woff2');unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Raleway';font-style:normal;font-weight:400;src:local('Raleway'), local('Raleway-Regular'), url(https://fonts.gstatic.com/s/raleway/v13/1Ptug8zYS_SKggPNyC0ITw.woff2) format('woff2');unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
@font-face{font-family:'Raleway';font-style:normal;font-weight:500;src:local('Raleway Medium'), local('Raleway-Medium'), url(https://fonts.gstatic.com/s/raleway/v13/1Ptrg8zYS_SKggPNwN4rWqhPAMif.woff2) format('woff2');unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Raleway';font-style:normal;font-weight:500;src:local('Raleway Medium'), local('Raleway-Medium'), url(https://fonts.gstatic.com/s/raleway/v13/1Ptrg8zYS_SKggPNwN4rWqZPAA.woff2) format('woff2');unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
@font-face{font-family:'Raleway';font-style:normal;font-weight:600;src:local('Raleway SemiBold'), local('Raleway-SemiBold'), url(https://fonts.gstatic.com/s/raleway/v13/1Ptrg8zYS_SKggPNwPIsWqhPAMif.woff2) format('woff2');unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Raleway';font-style:normal;font-weight:600;src:local('Raleway SemiBold'), local('Raleway-SemiBold'), url(https://fonts.gstatic.com/s/raleway/v13/1Ptrg8zYS_SKggPNwPIsWqZPAA.woff2) format('woff2');unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
@font-face{font-family:'Raleway';font-style:normal;font-weight:700;src:local('Raleway Bold'), local('Raleway-Bold'), url(https://fonts.gstatic.com/s/raleway/v13/1Ptrg8zYS_SKggPNwJYtWqhPAMif.woff2) format('woff2');unicode-range:U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Raleway';font-style:normal;font-weight:700;src:local('Raleway Bold'), local('Raleway-Bold'), url(https://fonts.gstatic.com/s/raleway/v13/1Ptrg8zYS_SKggPNwJYtWqZPAA.woff2) format('woff2');unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
</style>


// WEBPACK FOOTER //
// src/components/pages/page404.vue